var React = require('react');

function AwardsRightWave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M238.361 28.5799C184.595 28.008 126.248 18.3379 73.2111 28.9453C40.9188 35.4038 55.495 57.0092 75.038 72.0596C134.896 118.157 215.162 131.617 282.388 163.769C311.051 177.477 279.23 179.037 263.206 181.307C228.61 186.207 193.944 187.937 159.074 189.71C119.03 191.747 73.047 189.774 34.8467 204.508C-5.54946 220.089 79.1011 276.655 90.0184 283.612C123.346 304.85 159.819 320.644 196.525 334.947C223.563 345.483 237.552 350.106 263.937 358.696C271.756 361.242 280.9 361.415 287.321 366.552C291.902 370.217 275.632 367.563 269.783 368.013C255.993 369.074 242.297 369.845 228.496 370.571","stroke":"#40E0D0","strokeWidth":"47.6815","strokeLinecap":"round","strokeLinejoin":"round"}));
}

AwardsRightWave.defaultProps = {"width":"134","height":"395","viewBox":"0 0 134 395","fill":"none"};

module.exports = AwardsRightWave;

AwardsRightWave.default = AwardsRightWave;
